// src/pages/CatalogueMenuPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles, Crown, ArrowRight } from 'lucide-react';

const MenuSection = ({ title, subtitle, items }) => (
  <div className="mb-16">
    <div className="text-center mb-8">
      <h3 className="font-serif text-4xl text-[#971253] uppercase tracking-widest mb-2">{title}</h3>
      <p className="text-[#528a89] font-medium tracking-widest text-sm uppercase">{subtitle}</p>
    </div>
    <div className="space-y-6 max-w-3xl mx-auto">
      {items.map((item, idx) => (
        <div key={idx} className="group cursor-pointer hover:-translate-y-1 transition-transform duration-300">
          <div className="flex items-baseline justify-between mb-1">
            <h4 className="font-serif text-2xl text-[#528a89] group-hover:text-[#971253] transition-colors">{item.name}</h4>
            {/* Dotted line leader (Editorial Menu Style) */}
            <div className="flex-grow border-b-2 border-dotted border-[#dbcdac]/60 mx-4 relative top-[-6px]"></div>
            <span className="font-serif text-xl text-[#971253] font-bold">{item.players}</span>
          </div>
          <p className="text-stone-600 text-sm font-light leading-relaxed pr-12">
            <strong className="text-[#971253] text-xs uppercase tracking-wider mr-2">{item.time}</strong> 
            {item.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
);

function CatalogueMenuPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FFF5EE] pt-32 pb-24 px-6 relative overflow-hidden">
      {/* Background Texture/Ornament */}
      <div className="absolute top-0 left-0 w-full h-full opacity-[0.03] pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/aged-paper.png')]" />
      
      <div className="max-w-5xl mx-auto relative z-10 bg-white/40 p-8 md:p-16 rounded-3xl border border-[#dbcdac]/30 shadow-[0_0_60px_-15px_rgba(151,18,83,0.1)] backdrop-blur-sm">
        
        {/* Editorial Header */}
        <div className="text-center mb-20">
          <Crown className="mx-auto w-12 h-12 text-[#dbcdac] mb-6" />
          <h1 className="font-serif text-6xl md:text-8xl text-[#971253] mb-4">Menu de Jogos</h1>
          <p className="text-xl text-[#528a89] font-light italic">Escolha sua aventura para a noite.</p>
        </div>

        <MenuSection 
          title="Entradas Rápidas" 
          subtitle="Party Games & Quebra-Gelos"
          items={[
            { name: "Coup", players: "2-6 Jogadores", time: "15 MIN", desc: "Blefe, deduza e elimine a influência dos seus oponentes na corte. O último sobrevivente vence." },
            { name: "Taco Gato Cabra Queijo Pizza", players: "2-8 Jogadores", time: "10 MIN", desc: "Um jogo frenético de tapa na mesa. Fale a palavra certa, bata na carta certa, e cuidado com o gorila!" },
            { name: "Dixit", players: "3-8 Jogadores", time: "30 MIN", desc: "Uma imagem vale mil palavras. Dê dicas poéticas sobre cartas surreais e tente adivinhar a carta do narrador." }
          ]}
        />

        <MenuSection 
          title="Pratos Principais" 
          subtitle="Estratégia & Eurogames"
          items={[
            { name: "Catan", players: "3-6 Jogadores", time: "90 MIN", desc: "Negocie recursos, construa estradas e povoados na ilha de Catan. Um clássico moderno da estratégia." },
            { name: "Scythe", players: "1-5 Jogadores", time: "120 MIN", desc: "Europa alternativa de 1920. Controle facções, construa mechs gigantes e domine territórios em um jogo de peso pesado." }
          ]}
        />

        {/* CTA to Full Catalogue */}
        <div className="mt-24 text-center">
          <div className="h-[1px] w-32 bg-[#dbcdac] mx-auto mb-12" />
          <h3 className="font-serif text-2xl text-[#528a89] mb-6">Procurando algo específico?</h3>
          <button 
            onClick={() => navigate('/biblioteca/acervo')}
            className="group px-10 py-5 bg-[#971253] text-[#FFF5EE] rounded-full font-serif text-xl tracking-wide hover:bg-[#7a0e42] hover:shadow-xl transition-all border border-[#dbcdac]/50 flex items-center mx-auto gap-3"
          >
            Ver Acervo Completo <ArrowRight className="group-hover:translate-x-2 transition-transform" />
          </button>
        </div>

      </div>
    </div>
  );
}

export default CatalogueMenuPage;